import React from 'react';
import styled from 'styled-components';
// @ts-ignore
import icon from './download.svg';

type Props = {
  style?: any;
};
export default ({...props}: Props) => {
  return <Icon {...props} />;
};

const Icon = styled(icon)`
  width: 40px;
  height: 40px;
`;
